import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";

// Public pages
import { Home } from "./pages/Home";
import { ProductList } from "./pages/ProductList";
import { ProductDetail } from "./pages/ProductDetail";
import { Cart } from "./pages/Cart";
import { Checkout } from "./pages/Checkout";
import { OrderConfirmation } from "./pages/OrderConfirmation";
import ContactUs from "./pages/ContactUs";

// Customer pages
import Register from "./pages/customer/Register";
import Login from "./pages/customer/Login";
import Dashboard from "./pages/customer/Dashboard";
import Profile from "./pages/customer/Profile";
import OrderDetail from "./pages/customer/OrderDetail";
import MessageDetail from "./pages/customer/MessageDetail";

// Admin pages
import { Login as AdminLogin } from "./pages/admin/Login";
import { Dashboard as AdminDashboard } from "./pages/admin/Dashboard";
import { Products } from "./pages/admin/Products";
import { Orders } from "./pages/admin/Orders";
import { Settings } from "./pages/admin/Settings";
import Users from "./pages/admin/Users";
import ContactMessages from "./pages/admin/ContactMessages";
import AdminSettings from "./pages/admin/AdminSettings";

import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <CustomerAuthProvider>
          <AuthProvider>
            <CartProvider>
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="products" element={<ProductList />} />
                <Route path="products/:category" element={<ProductList />} />
                <Route path="product/:slug" element={<ProductDetail />} />
                <Route path="cart" element={<Cart />} />
                <Route path="checkout" element={<Checkout />} />
                <Route path="order/:orderNumber" element={<OrderConfirmation />} />
                <Route path="contact" element={<ContactUs />} />

                {/* Customer Authentication */}
                <Route path="register" element={<Register />} />
                <Route path="login" element={<Login />} />

                {/* Customer Account Routes */}
                <Route path="account" element={<Dashboard />} />
                <Route path="account/profile" element={<Profile />} />
                <Route path="account/orders/:orderNumber" element={<OrderDetail />} />
                <Route path="account/messages/:messageId" element={<MessageDetail />} />
              </Route>

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <Layout admin />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="products" element={<Products />} />
                <Route path="orders" element={<Orders />} />
                <Route path="users" element={<Users />} />
                <Route path="contact-messages" element={<ContactMessages />} />
                <Route path="settings" element={<Settings />} />
                <Route path="account" element={<AdminSettings />} />
              </Route>
            </Routes>
            </CartProvider>
          </AuthProvider>
        </CustomerAuthProvider>
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;
